import React, { useEffect, useRef, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'react-bootstrap';
import { BsPlus } from 'react-icons/bs';
import RenderFieldInput from '../../../input/renderFieldInput';
import { required, maxLength } from 'utils/validation';
import { connect } from 'react-redux';

import { some, filter, uniqBy } from 'lodash';

import { v4 as uuidv4 } from 'uuid';
import {
  setCategory,
  saveCategoryRequest,
  setToast,
} from 'containers/client/actions';
import { saveState } from 'lib/storages';
import { makeGetToken, makeGetCategory } from 'lib/selector';
import { translate } from 'react-i18next';

const maxLength20 = maxLength(20);

const DropdownAddStock = (props) => {
  const wrapperRef = useRef();
  const [showDrop, setShowDrop] = useState(false);
  const { handleSubmit, pristine, submitting, t } = props;

  const submit = (value) => {
    const { categoryName } = value;
    const { category, setCategory, setToast, reset } = props;

    console.log(category, categoryName);

    const countWatchList = filter(category, (o) => o.type === 'watchlist');
    if (countWatchList && countWatchList.length >= 15) {
      const toastMsg = {
        id: Math.random(),
        msg: t('txt-valid-5-catalog'),
        title: t('txt-notice'),
      };
      setToast(toastMsg);
      return;
    }

    if (
      some(category, (o) => o.type === 'watchlist' && o.name === categoryName)
    ) {
      const toastMsg = {
        id: Math.random(),
        msg: t('txt-valid-exist-category') + categoryName,
        title: t('txt-notice'),
      };
      setToast(toastMsg);
      return;
    }
    const uuid = uuidv4();
    // add category
    const catalog = {
      id: uuid,
      name: categoryName,
      path: '/home/bang-gia/' + uuid,
      pinnedRow: [],
      value: [],
      type: 'watchlist',
    };

    const _newCategory = uniqBy([...category, catalog], 'path');
    console.log(_newCategory);
    setCategory(_newCategory);
    _handleSaveCategory(catalog);
    saveState('category', _newCategory);
    reset();
    setShowDrop(false);
  };

  const _handleSaveCategory = (_newCategory) => {
    const { token, saveCategoryRequest } = props;

    if (!token) return;

    const uuid = uuidv4();
    const resData = {
      group: 'BACK',
      user: token.user,
      session: token.session,
      cmd: 'SET_WAT',
      rqId: uuid,
      channel: 'WTS',
      data: _newCategory,
    };

    saveCategoryRequest(resData);
  };

  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside);
    // See note below
    return () => window.removeEventListener('mousedown', handleClickOutside);
  });

  const handleClickOutside = (event) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShowDrop(false);
    }
  };

  return (
    <div className=" mr-2 position-relative">
      <div
        onClick={() => setShowDrop(!showDrop)}
        className="text-center"
        style={{
          width: '41px',
          height: '26px',
          borderRadius: '13px',
          backgroundColor: '#6a7094',
        }}
      >
        <BsPlus className="text-white" />
      </div>
      {showDrop && (
        <form
          ref={wrapperRef}
          onSubmit={handleSubmit(submit)}
          className="picker-add bg-light form-inline p-2"
          style={{
            minWidth: '250px',
            borderRadius: '10px',
            flexFlow: 'nowrap',
          }}
        >
          <Field
            name="categoryName"
            type="text"
            id="categoryName"
            className="form-control fz-14"
            placeholder={t('txt-portfolio')}
            component={RenderFieldInput}
            validate={[required, maxLength20]}
          />
          <Button
            variant="secondary"
            type="submit"
            disabled={pristine || submitting}
            className="d-flex ml-2"
          >
            <BsPlus className="text-white" />
          </Button>
        </form>
      )}
    </div>
  );
};

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getCategory = makeGetCategory();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      category: getCategory(state),
    };
  };
  return mapStateToProps;
};

const connected = connect(makeMapStateToProps, {
  setCategory,
  saveCategoryRequest,
  setToast,
})(DropdownAddStock);

const formed = reduxForm({
  form: 'addStock',
})(connected);

export default translate('translations')(formed);
